
import HeaderMenu from './index.vue'
// 为组件提供 install 方法
HeaderMenu.install = function (Vue) {
    Vue.component(HeaderMenu.name, HeaderMenu)
}
// 导出组件
export default HeaderMenu
